import styled from "styled-components";

export const Heading = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.heading};
`;

export const Subheading = styled.h2`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.subheading};
`;

export const SmallHeading = styled.h3`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.smallHeading};
`;
